import React from 'react';
// import { useLoaderData } from "react-router-dom";

import jsonfile from '../../../../../apple-app-site-association.json';

const AppleFile: React.FC = () => {
  // const data = useLoaderData();
  return <pre>{JSON.stringify(jsonfile, null, 2)}</pre>;
  // return <pre>{JSON.stringify(data, null, 2)}</pre>;
};

export default AppleFile;
